<template>
  <div>
    <div class="rpt-content">
      <div style="margin-bottom: 20px;">
        <div class="search-control-item">
          <el-input v-model="inputValue" placeholder="请输入内容" class="input-with-select" style="width: 500px;">
            <el-select style="width: 170px;" v-model="selectType" slot="prepend" placeholder="请选择">
              <el-option label="企业名称" value="company_name"></el-option>
              <el-option label="统一社会信用代码" value="credit_code"></el-option>
            </el-select>
          </el-input>
        </div>
        <region class="search-control-item" v-model="regionId" />
        <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
      <el-table border v-loading="tableloading" :data="listData" style="width: 100%" max-height="700">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
        <el-table-column prop="credit_code" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="tel" label="管理员账号"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 1 ? '已认证' : '未认证' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="province_name" label="所在省份"></el-table-column>
        <el-table-column prop="city_name" label="所在城市"></el-table-column>
        <el-table-column prop="area_name" label="所在区域"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'not-apply-company',
  data() {
    return {
      selectType: 'company_name',
      inputValue: '',
      regionId: [],
      tableloading: false,
      listData: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.tableloading = true;
      let region = '';
      if (this.regionId.length == 1) {
        region = `&province_id=${this.regionId[0]}`;
      } else if (this.regionId.length == 2) {
        region = `&province_id=${this.regionId[0]}&city_id=${this.regionId[1]}`;
      } else if (this.regionId.length == 3) {
        region = `&province_id=${this.regionId[0]}&city_id=${this.regionId[1]}&area_id=${this.regionId[2]}`;
      }
      request({
        url: `/api/rpt/not/apply/company?${this.selectType}=${this.inputValue}${region}`
      }).then(res => {
        this.tableloading = false;
        if (res.success) {
          this.listData = res.result;
        }
      });
    }
  }
};
</script>

<style></style>
